export const vuexDefaultMapping = {
  state: ['list', 'page', 'status', 'pages', 'count'],
  actions: [
    'fetchList',
    'fetchRemove',
    'prevPage',
    'nextPage',
    'firstPage',
    'lastPage',
  ],
  getters: ['loading'],
  mutations: ['setQuery'],
}

export default {
  data() {
    return { errors: [] }
  },
  methods: {
    search() {
      this.setPage(1)
      this.fetchList()
    },
    addErrors(errors) {
      this.errors = errors
    },
  },
}
